/**
 * Return a hardcoded computed keyword.
 * This is bad practice, however due to historical issues, this is currently necessary.
 * @param {string} keyword - The search keyword
 * @returns The computed keyword.
 */
const computedKeyword = keyword => {
  switch (keyword) {
    case 'Pawnbrokers':
      return `${keyword} & Pawn Shops Near You`;
    case 'Roadworthy & Safety Certificates':
      return `${keyword} & Blue Slips`;
    case 'Vehicle Inspections':
      return `${keyword} & Pink Slips`;
    default:
      return keyword;
  }
};

const LISTVIEW_PRIMARY_H1 = ({ keyword, suburb, state, postcode }) => {
  const h1 = `BEST ${computedKeyword(keyword)} in ${suburb} ${state}`;
  const currentYear = new Date().getFullYear();
  return `${h1}${postcode ? ` ${postcode}` : ''}${
    state === 'NT' ? ` for ${currentYear}` : ''
  }`;
};

export default LISTVIEW_PRIMARY_H1;
